import React from "react";
import { useFormikContext } from "formik";
import { CustomCard } from "../../../../../Components/";
import { OptionalFieldDetails } from "../OptionalFieldDetails";
import { optionalFieldNames } from "../../util";
import { useSelectedTheme } from "../../../../../Hooks";

import useStyles from "../styles";

import { CloseXIcon } from "../../../../../assets/icons";

function ActiveOptionalField({ activeOptionalFields, onCloseHandler }) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const optionalDetailsContent = OptionalFieldDetails();
  const { setFieldValue } = useFormikContext();

  return (
    <div>
      {activeOptionalFields.map((activeField) => (
        <CustomCard
          boxShadow="xs"
          borderRadius="xl"
          borderColor="secondary"
          classes={styles.optionalFieldWrapper}
          key={activeField.key}
        >
          <CloseXIcon
            onClick={() => {
              onCloseHandler(activeField.value);
              optionalFieldNames[activeField.value].forEach((fieldName) => {
                setFieldValue(fieldName, []);
              });
            }}
            className={styles.closeXIcon}
            width="20"
            height="20"
            fill={palette.text.primary}
          />
          {optionalDetailsContent[activeField.value]()}
        </CustomCard>
      ))}
    </div>
  );
}

export default ActiveOptionalField;
